define('core/views/DynamicHeightRichMediaView',[
    'underscore',
    'core/views/RichMediaView',
], function (
    _,
    RichMediaView
) {
    'use strict';

    return RichMediaView.extend({
        insertContentNode: function () {
            RichMediaView.prototype.insertContentNode.apply(this, arguments);

            this.finishLoad();
        },

        finishLoad: function () {
            var self = this;

            // With dynamic-height content, an initial measurement is most likely
            // inaccurate. Since load times vary, an acceptable solution is to
            // re-measure the height at a regular rate.
            var callCount = 0;
            var CALL_RATE = 150;
            var MAX_CALLS = 20;
            var updateFunction = function () {
                callCount += 1;
                if (callCount < MAX_CALLS)
                    _.delay(updateFunction, CALL_RATE);
                else
                    self.trigger('load');
            };
            updateFunction();
        },
    });
});

